














import { defineComponent } from '@vue/composition-api'

// Components
import FacetBlockTitle from './FacetBlockTitle.vue'
import FacetBlockLoop from './FacetBlockLoop.vue'
import FacetAccordion from '@/components/feature/search/facets/FacetAccordion.vue'

// Composables
import useFacets from '@/composables/search/useFacets'

export default defineComponent({
  components: {
    FacetAccordion,
    FacetBlockTitle,
    FacetBlockLoop,
  },

  props: {
    facetkey: {
      type: String,
      required: true,
      default: '',
    },
    facetvalue: {
      type: Array,
      required: true,
      default: () => [],
    },
  },

  setup() {
    const { existingFacetIndex } = useFacets()

    return {
      existingFacetIndex,
    }
  },
})
